
const sliders = document.querySelectorAll('.slider');
const breakpointSm = window.matchMedia('(max-width: 767px)');
let swiperList = [];

const initsliders = () => {
  if (sliders.length) {
    sliders.forEach((item, i) => {
      swiperList[i] = new Swiper(item, {
        slidesPerView: 1,
        centeredSlides: false,
        navigation: {
          nextEl: '.slider__button--next',
          prevEl: '.slider__button--prev',
        },
        pagination: {
          el: '.slider__pagination',
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            centeredSlides: false,
          },
        },
      });
    });
  }
};
const initSlider = () => {
  if (sliders.length) {
    const breakpointChecker = () => {
      if (!breakpointSm.matches) {
        if (swiperList.length) {
          for (let i = 0; i < swiperList.length; i++) {
            swiperList[i].destroy(true, true);
          }
        }
      } else {
        if (swiperList.length) {
          for (let i = 0; i < swiperList.length; i++) {
            swiperList[i].destroy(true, true);
          }
        }
        swiperList = [];
        initsliders();
      }
    };
    breakpointSm.addListener(breakpointChecker);
    breakpointChecker();
  }
};
export {initSlider};
